<template>
  <div>
    <a
      href="#"
      class="dropdown-toggle"
      role="button"
      id="dropdownMenuLink"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      >{{ currentLang.name }}</a
    >

    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
      <a
        class="dropdown-item"
        href="#"
        v-for="(lang, i) in otherLangs"
        :key="'lang' + i"
        @click="updateLanguage(lang)"
        ref="languageSelector"
        value="lang.iso_code"
        >{{ lang.name }}</a
      >
    </div>
  </div>
</template>

<script>
import { loadLanguages } from '@/api/navItems';
import config from '@/config';
import _ from 'lodash';
export default {
  data() {
    return {
      otherLangs: [],
      currentLangName: '',
      currentLang: {
        name: '',
        iso_code: ''
      }
    };
  },
  async mounted() {
    this.langs = await loadLanguages();
    this.currentLang = _.isEmpty(this.$store.state.language)
      ? this.getLanguage(config.DEFAULT_LANGUAGE)
      : this.$store.state.language;
    this.otherLangs = this.langs.filter(o => o.iso_code !== this.currentLang.iso_code);
  },
  computed: {},
  methods: {
    updateLanguage(lang) {
      this.$store.dispatch('SET_LANGUAGE', lang);
      this.currentLang = lang;
      this.otherLangs = this.langs.filter(o => o.iso_code !== this.currentLang.iso_code);
      this.$root.$emit('update-language', lang);
    },
    getLanguage(iso) {
      return this.langs.filter(o => o.iso_code == iso)[0];
    }
  }
};
</script>

<style lang="scss" scoped></style>
